module.exports = __webpack_public_path__ + "img/image008.3ac8664f.jpg";